import { render, staticRenderFns } from "./PaginationInput.vue?vue&type=template&id=59768374&"
import script from "./PaginationInput.vue?vue&type=script&lang=js&"
export * from "./PaginationInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports